/**
 * @generated SignedSource<<a7b2d9131c3886f56b8f59c993069b4e>>
 * @relayHash f7f0dff862f6678572fce8ab9a4a7740
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3b5c85a27817092ac3aa04910cb54034a2f8c1032f0fd41ce9cce863affe222

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateColorFieldInput = {
  id: string;
  operation: JiraColorFieldOperationInput;
};
export type JiraColorFieldOperationInput = {
  color: string;
  operation: JiraSingleValueFieldOperations;
};
export type ui_issueViewLayoutColorField_IssueViewColorField_Mutation$variables = {
  input: JiraUpdateColorFieldInput;
};
export type ui_issueViewLayoutColorField_IssueViewColorField_Mutation$data = {
  readonly jira: {
    readonly updateColorField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly color: {
          readonly colorKey: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueViewLayoutColorField_IssueViewColorField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateColorField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly color: {
          readonly colorKey: string | null | undefined;
          readonly id: string | null | undefined;
        } | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueViewLayoutColorField_IssueViewColorField_Mutation = {
  rawResponse: ui_issueViewLayoutColorField_IssueViewColorField_Mutation$rawResponse;
  response: ui_issueViewLayoutColorField_IssueViewColorField_Mutation$data;
  variables: ui_issueViewLayoutColorField_IssueViewColorField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_issueViewLayoutColorField_IssueViewColorField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraColorFieldPayload",
            "kind": "LinkedField",
            "name": "updateColorField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraColorField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_issueViewLayoutColorField_IssueViewColorField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraColorFieldPayload",
            "kind": "LinkedField",
            "name": "updateColorField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraColorField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c3b5c85a27817092ac3aa04910cb54034a2f8c1032f0fd41ce9cce863affe222",
    "metadata": {},
    "name": "ui_issueViewLayoutColorField_IssueViewColorField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4e8ed1ed7e1ce2f2d05ffdcb628b762e";

export default node;
